/* State hub - zone accordions at <768px only. Content is always in the DOM;
   panels are toggled with aria-expanded + hidden. Without JS (or at >=768px)
   every panel renders open (see .sh-zone__panel[hidden] in state-hub.css). */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 767px)');
  var roots = document.querySelectorAll('[data-sh-zones]');
  if (!roots.length) return;

  function setOpen(btn, open) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
  }

  function apply() {
    Array.prototype.forEach.call(roots, function (root) {
      var btns = root.querySelectorAll('[data-sh-zone-toggle]');
      if (mq.matches) {
        root.classList.add('sh--js');
        Array.prototype.forEach.call(btns, function (b) {
          if (!b.getAttribute('data-sh-init')) { setOpen(b, false); b.setAttribute('data-sh-init', '1'); }
        });
      } else {
        root.classList.remove('sh--js');
        Array.prototype.forEach.call(btns, function (b) { setOpen(b, true); b.removeAttribute('data-sh-init'); });
      }
    });
  }

  Array.prototype.forEach.call(roots, function (root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sh-zone-toggle]');
      if (!btn || !mq.matches) return;
      setOpen(btn, btn.getAttribute('aria-expanded') !== 'true');
    });
  });

  apply();
  if (mq.addEventListener) { mq.addEventListener('change', apply); } else { mq.addListener(apply); }
})();
